"use client";

import BFLTabs from "@repo/shared-ui/BFLTabs";
import { useCallback, useEffect, useState } from "react";
import { detectPageType, trackTabClick } from "./tradingSection";
import { handleRedirection } from "../../utils/helper";
import { TabItem } from "./types";
import { useRouter } from "next/navigation";

interface TradingSectionProps {
  tabs: TabItem[];
}

export default function TradingSectionClient({ tabs }: TradingSectionProps) {
  const [activeTab, setActiveTab] = useState<string>(
    tabs[0]?.value || "stocks",
  );
  const [pageName, setPageName] = useState<boolean>(false);
  const router = useRouter();

  useEffect(() => {
    setPageName(detectPageType());
  }, []);

  const handleTabChange = useCallback(
    (newTabValue: string) => {
      const selectedTab = tabs.find((tab) => tab.value === newTabValue);
      if (!selectedTab || activeTab === newTabValue) return;

      try {
        trackTabClick(selectedTab, pageName);
        handleRedirection(selectedTab.redirectLink, router);
      } catch (error) {
        console.error("Tab change error:", error);
        setActiveTab(newTabValue);
      }
    },
    [activeTab, tabs, pageName],
  );


  return (
    <div>
      <BFLTabs
        className="boder-none px-0 pb-0 pl-[16px] pt-[16px] text-[12px] md:pt-[12px] lg:text-[16px]"
        tabClassName="relative text-[#002953] cursor-pointer whitespace-nowrap  p-0 mr-[12px] md:mr-[36px]"
        gapClassName="md:pb-[12px] pb-[8px]"
        indicatorClassName="md:bottom-[-13px] bottom-[-10px]"
        color="text-[#002953]"
        selectedTab={activeTab}
        onTabChange={handleTabChange}
        tabs={tabs ?? []}
      />
    </div>
  );
}
